import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import AppDialog from "~/shared/ui/AppDialog";
import { useNotify } from "~/shared/ui/feedback/SnackbarProvider";
import { showDoctorCompany, updateDoctorCompany } from "~/services/antecipebackoffice/doctors";

const EMPTY = { company_name: "", cnpj: "", company_address: "", company_cep: "", rg: "", rg_issuer: "" };
// [campo, rótulo, texto de ajuda]
const FIELDS = [
  ["company_name", "Razão Social"],
  ["cnpj", "CNPJ"],
  ["company_address", "Endereço"],
  ["company_cep", "CEP"],
  ["rg", "RG", "Insira os pontos (.) e traços (-) no RG se for necessário."],
  ["rg_issuer", "Emissor do RG"],
];

const EditDoctorPJModal = ({ open, setOpen, handleClose, idDoctor, doctorName, readOnly = false }) => {
  const notify = useNotify();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    showDoctorCompany(idDoctor).then(
      ({ data }) => alive && setForm({ ...EMPTY, ...data }),
      () => alive && setError("Não foi possível carregar os dados de pessoa jurídica.")
    );
    return () => {
      alive = false;
    };
  }, [idDoctor]);

  const close = (e) => {
    if (saving) return;
    if (typeof handleClose === "function") handleClose(e);
    setOpen(false);
  };

  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      await updateDoctorCompany(idDoctor, form);
      setSaving(false);
      setOpen(false);
      notify({ severity: "success", message: "Dados PJ Atualizado com Sucesso!" });
    } catch (e) {
      setSaving(false);
      setError("Erro ao atualizar dado PJ, por favor preencha todos os campos obrigatórios!");
    }
  };

  return (
    <AppDialog
      open={open}
      onClose={close}
      size="md"
      busy={saving}
      title="Dados Pessoa Jurídica"
      context={`Médico: ${doctorName}`}
      actions={
        <>
          <Button onClick={close} disabled={saving} sx={{ color: "text.primary" }}>
            {readOnly ? "Fechar" : "Cancelar"}
          </Button>
          {!readOnly && (
            <LoadingButton variant="contained" loading={saving} onClick={save}>
              Atualizar dados PJ
            </LoadingButton>
          )}
        </>
      }
    >
      <Box
        data-testid="pj-grid"
        component="fieldset"
        disabled={readOnly}
        sx={{
          border: 0,
          p: 0,
          m: 0,
          minWidth: 0,
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", sm: "2fr 1fr" },
        }}
      >
        {FIELDS.map(([field, label, helperText]) => (
          <TextField
            key={field}
            disabled={readOnly}
            required
            label={label}
            helperText={helperText}
            value={form[field] || ""}
            onChange={(e) => setForm((f) => ({ ...f, [field]: e.target.value }))}
          />
        ))}
      </Box>
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </AppDialog>
  );
};

export default EditDoctorPJModal;
